var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2071 0.292893C17.5976 0.683417 17.5976 1.31658 17.2071 1.70711L8.62132 10.2929C7.44975 11.4645 5.55026 11.4645 4.37868 10.2929L0.792893 6.70711C0.402369 6.31658 0.402369 5.68342 0.792893 5.29289C1.18342 4.90237 1.81658 4.90237 2.20711 5.29289L5.79289 8.87868C6.18342 9.2692 6.81658 9.26921 7.20711 8.87868L15.7929 0.292893C16.1834 -0.0976311 16.8166 -0.0976311 17.2071 0.292893Z",
    fill: "#83BF6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.029564181595f21a881d0c8cf7f02601.svg";
export { ForwardRef as ReactComponent };